<template>
  <el-menu :collapse="isSidebarNavCollapse" background-color="#fff" text-color="#333" active-text-color="#4dbcff" :default-active="currentMenu" :unique-opened="true">
    <DynamicMenu :menuList="sidebarMenu"></DynamicMenu>
  </el-menu>
</template>

<script>
import DynamicMenu from '@/components/dynamic-menu';
import { mapState } from 'vuex';

export default {
  data () {
    return {
      isCollapse: true
    };
  },
  computed: {
    ...mapState(['isSidebarNavCollapse']),
    ...mapState('permission', ['sidebarMenu', 'currentMenu'])
  },
  methods: {},
  components: {
    DynamicMenu
  }
}
</script>


// WEBPACK FOOTER //
// src/page/layout/component/main-content/sidebar-nav.vue